import { Role } from '../role/role';
import { Status } from '../status/status';

export class Mail {
    id: number;
    dealerNumber: number;
    address: string;

    status: Status;
    role: Role;
}